<style scoped>
    .title{
        font-size: .3rem;
        color: #010101;
        font-weight: bold;
        margin: .3rem .24rem;

    }
    .list{
        padding: 0 .24rem;
    }

    ul li{
        padding: .3rem .24rem;
        background: #fff;
        margin-bottom: .18rem;
        box-shadow: .01rem .03rem .09rem 0 rgba(157, 157, 157, 0.19), 0 0 0 0 rgba(141, 141, 141, 0.35);
        border-radius: .1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .itemLeft{
        display: flex;
    }
    li img{
        width: 1.2rem;
        height: 1.2rem;
        border-radius: .1rem;
        object-fit: cover;
        margin-right: .24rem;
    }

    .itemTitle{
        font-size: .3rem;
        color: #010101;
        font-weight: bold;
        margin-bottom: .32rem;
    }

    .tagline{
        font-size: .26rem;
        color: #7E7E7E;
    }

    .center{
        max-width: 3.6rem;
    }

    .btn{
        width: 1.4rem;
        height: .6rem;
        background: #369AF0;
        border-radius: .3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .28rem;
        color: #fff;
    }

    .btn.active{
        background: #fff;
        color: #369AF0;
        border: .02rem solid #369AF0;
    }

    .viewReport{
        width: 6rem;
        height: .8rem;
        background: #369AF0;
        border-radius: .4rem;
        font-size: .3rem;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: .7rem auto;
    }
</style>
<template>
    <div style="padding-top: 1rem">
        <topbar text="心理评测" status="true"></topbar>
        <div class="title">矫正对象风险因子综合评估</div>
        <ul class="list" v-if="!emptyStatus">
            <li v-for="(item,index) in scaleGroupComboRecordDTOList" @click="toWhere(item.scaleId,item.testId,item.testStatus)">
                <div class="itemLeft">
                    <img :src="EnvUrl + item.pic" alt="">
                    <div class="center">
<!--                        <div class="itemTitle">{{item.title}}</div>-->
                        <div class="itemTitle">心理评测{{index+1}}</div>
                        <div class="tagline">{{item.tagline}}</div>
                    </div>
                </div>

                <div class="btn" v-if="!item.testStatus">去测试</div>
                <div class="btn active" v-if="item.testStatus">已测试</div>
            </li>
        </ul>
        <no-more-data :noMoreData="noMoreData"></no-more-data>
<!--        <div class="viewReport" v-if="testStatus" @click="to(`correctResult?recordId=${recordId}&comboId=${comboId}`)">查看报告</div>-->
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                slidesReal: [],
                scaleLabelList: [],
                scaleGroupComboRecordDTOList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: false,
                userId: '',
                recordId: '',
                comboId:''
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isDuration(value){
                let result = parseInt(value)
                let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
                let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
                let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

                let res = '';
                if(h !== '00') res += `${h}:`;
                if(m !== '00') res += `${m}:`;
                res += `${s}`;
                return res;
            }
        },
        computed: {},
        methods: {
            toWhere(scaleId,testId,status){
                if(status){

                }else{
                    this.to(`topic?scaleId=${scaleId}&testId=${testId}&groupId=${this.scaleGroup.groupId}&comboId=${this.comboId}`)
                }
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getScaleGroupComboRecord()
                    }
                }
            },
            async getScaleGroupComboRecord() {
                let obj = {}
                obj.groupId = this.$route.query.groupId;
                obj.userId = this.userId;
                let data = await getSources("/bear-scale/api/scaleGroup/getScaleGroupComboRecord.json", obj);
                if (data.status === 0) {
                    this.recordId = data.recordId;
                    this.comboId = data.comboId;
                    this.testStatus=data.testStatus
                    this.scaleGroup = data.scaleGroup;
                    this.scaleGroupComboRecordDTOList = [...this.scaleGroupComboRecordDTOList, ...data.scaleGroupComboRecordDTOList];
                    // if (data.microList.length == 0) {
                    //     this.emptyStatus = true
                    // } else {
                    //     console.log(111111)
                    //     if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                    //         console.log('显示')
                    //         this.noMoreData = true
                    //     } else {
                    //         console.log(2)
                    //         this.noMoreData = false
                    //     }
                    // }

                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.userId=localStorage.getItem('userId')
            this.getScaleGroupComboRecord();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/mentalExperience.vue?69d57a10